
























































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import Pagination from '@morpheus/utils/admin-vue/mixins/pagination'
import { exportCodes, fetchCodesExportsListByGeneratorId } from '../../services/printable-codes-client'
import { CodesExportData, CodesExportsListData, CodesExportsListItemData } from '../../types'
import CodesExportList from '../../components/export/CodesExportList.vue'
import CodesExportForm from '../../components/export/CodesExportForm.vue'

export default mixins(Pagination).extend({
  name: 'CodesGeneratorExport',
  components: {
    CodesExportForm,
    CodesExportList
  },
  mixins: [Pagination],
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      clearForm: false,
      isLoading: true,
      headers: [
        { text: 'ID', value: '_id', sortable: false },
        { text: 'GeneratorID', value: 'generator_id', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Comment', value: 'comment', sortable: false },
        { text: 'Created By', value: 'created_by', sortable: false },
        { text: 'Created At', value: 'created_at', sortable: false },
        { text: 'Actions', value: '_id', align: 'center', sortable: false }
      ],
      itemsList: []
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchCodesExportsListByGeneratorId(this.id, `?limit=${this.rowsPerPage}&offset=${this.paginationOffset}`)
        .then(({ items, total }: CodesExportsListData) => {
          this.itemsList.splice(0, this.itemsTotal)
          items.forEach((item: CodesExportsListItemData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
          this.itemsTotal = total
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.checkPagination()
          this.$store.commit('global/setLoading', false)
          this.isLoading = false
        })
    },
    codesExportFormSubmit (param: CodesExportData) {
      this.isLoading = true

      exportCodes(param)
        .then(response => {
          this.clearForm = true
          this.$store.commit('global/addNotification', {
            text: 'You successfully started the export process!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onClearForm () {
      this.clearForm = false
    }
  }
})
